export var brBranches = {
  cn: {
    name: "中文",
    head: "其他语言",
    url: "http://backrooms-wiki-cn.wikidot.com/",
    id: "4716348",
    category: "",
  },
  en: {
    name: "English",
    head: "Languages",
    url: "http://backrooms-wiki.wikidot.com/",
    id: "4431268",
    category: "",
  },
  es: {
    name: "Español",
    head: "En otros idiomas",
    url: "http://es-backrooms-wiki.wikidot.com/",
    id: "4745515",
    category: "",
  },
  fr: {
    name: "Français",
    head: "Dans d’autres langues",
    url: "http://fr-backrooms-wiki.wikidot.com/",
    id: "4710749",
    category: "",
  },
  id: {
    name: "Bahasa Indonesia",
    head: "Bahasa lainnya",
    url: "http://id-backrooms-wiki.wikidot.com/",
    id: "4760096",
    category: "",
  },
  jp: {
    name: "日本語",
    head: "他言語版",
    url: "http://japan-backrooms-wiki.wikidot.com/",
    id: "4864894",
    category: "",
  },
  pl: {
    name: "Polski",
    head: "W innych językach",
    url: "http://pl-backrooms-wiki.wikidot.com/",
    id: "4761123",
    category: "",
  },
  ptbr: {
    name: "Português",
    head: "Em outros idiomas",
    url: "http://pt-br-backrooms-wiki.wikidot.com/",
    id: "4714912",
    category: "",
  },
  ru: {
    name: "Русский",
    head: "На других языках",
    url: "https://ru-backrooms-wiki.wikidot.com/",
    id: "4548260",
    category: "",
  },
  vn: {
    name: "Tiếng Việt",
    head: "Ngôn ngữ",
    url: "http://backrooms-vn.wikidot.com/",
    id: "4748367",
    category: "",
  },
};
